import {Alert, Button, Form, Modal, ToggleButton, ToggleButtonGroup} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import Select from "react-select";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import useToken from "../../../hooks/useToken";

const options = [
    { label: 'Soins', value: 'care' },
    { label: 'Prothèses / Orthodontie', value: 'prosthesis_orthodontics' }
]

const apiURL = process.env.REACT_APP_API_URL

const Step1Document = ({tiersPayant, loading, handleClose, onSubmit, apiErrors, currentStep, stepsConfig, onClickStep}) => {
    const { t } = useTranslation();
    const [type, setType] = useState(0)
    const [showInvoiceFile, setShowInvoiceFile] = useState(true)
    const [showInsuranceCardFile, setShowInsuranceCardFile] = useState(true)
    const [hasInsuranceCardFile, setHasInsuranceCardFile] = useState(true)
    const [hasMedicalCareFile, setHasMedicalCareFile] = useState(true)
    const [hasMedicalCareFileToDownload, setHasMedicalCareFileToDownload] = useState(false)
    const [medicalCareFileId, setMedicalCareFileId] = useState(false)
    const [needToValidateRemainingAmount, setNeedToValidateRemainingAmount] = useState(false)
    const [isRemainingAmountIsValid, setIsRemainingAmountIsValid] = useState(false)
    const {token} = useToken()

    const {
        register,
        handleSubmit,
        formState: { errors: formErrors },
        control,
        setValue,
        setError,
    } = useForm({})

    useEffect(() => {
        if (apiErrors !== null && Object.keys(apiErrors).length > 0) {
            Object.keys(apiErrors).forEach((key) => {
                setError(key, apiErrors[key])
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiErrors]);

    useEffect(() => {
        if (tiersPayant) {
            if (tiersPayant.type) {
                setValue('type', tiersPayant.type)
                setType(tiersPayant.type)
            }
            if (tiersPayant.invoiceFile) {
                setShowInvoiceFile(false)
            }

            if (false === tiersPayant.hasInsuranceCardFile) {
                setValue('hasInsuranceCardFile', true)
                setHasInsuranceCardFile(false)
            }

            if (tiersPayant.insuranceCardFile && false !== tiersPayant.hasInsuranceCardFile) {
                setShowInsuranceCardFile(false)
                setHasInsuranceCardFile(true)
            }

            if (false === tiersPayant.hasMedicalCareFile) {
                setValue('hasMedicalCareFile', true)
                setHasMedicalCareFile(false)
            }
            if (true === tiersPayant.hasMedicalCareFile) {
                setValue('hasMedicalCareFile', false)
                setHasMedicalCareFile(true)
                if (tiersPayant.medicalCareFile) {
                    setMedicalCareFileId(tiersPayant.medicalCareFile.id)
                    setHasMedicalCareFileToDownload(false)
                }
                //setShowMedicalCareFile(false)
                //setHasMedicalCareFile(true)
            }

            if (true === tiersPayant.isRemainingAmountIsValid)
            {
                setValue('isRemainingAmountIsValid', 'true')
                setIsRemainingAmountIsValid(true)
            }
            if (false === tiersPayant.isRemainingAmountIsValid)
            {
                setValue('isRemainingAmountIsValid', 'false')
                setIsRemainingAmountIsValid(false)
            }
            setNeedToValidateRemainingAmount((tiersPayant && tiersPayant.type === 'care' && tiersPayant.remainingAmount >= 50) || (tiersPayant && tiersPayant.type === 'prosthesis_orthodontics' && tiersPayant.remainingAmount <= 50))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tiersPayant]);

    return (
        <>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-3" controlId="tiers-payant.nirCode">
                    <Form.Label>{t('tiers-payant.manage.form.type.label')}</Form.Label>
                    <Controller
                        name="type"
                        control={control}
                        rules={{ required: 'error-empty' }}
                        render={({field}) => (
                            <Select
                                name={field.name}
                                placeholder={t('tiers-payant.manage.form.type.place-holder')}
                                inputRef={field.ref}
                                options={options}
                                value={options.find((c) => c.value === field.value)}
                                onChange={val => {
                                    field.onChange(val.value)
                                    setType(val.value)
                                    setNeedToValidateRemainingAmount((val.value === 'care' && tiersPayant.remainingAmount >= 50) || (val.value === 'prosthesis_orthodontics' && tiersPayant.remainingAmount <= 50))
                                }}
                                isInvalid={formErrors && formErrors.type}
                                className={`p-0 form-control form-control-lg ${formErrors && formErrors.type ? ' is-invalid' : ''}`}
                            />)
                        }
                    />
                    {formErrors && formErrors.nirCode && (
                        <Form.Control.Feedback type="invalid">
                            {t(`tiers-payant.manage.form.type.errors.${formErrors.nirCode.message}`)}
                        </Form.Control.Feedback>
                    )}
                    </Form.Group>

                {type === 'care' && needToValidateRemainingAmount && <div>
                    <Form.Group className="mb-3" controlId="tiers-payant.is-cancel-on-client-care">

                        <Alert variant="warning">
                            <div className="alert-message">
                                <Form.Label>{t('tiers-payant.manage.form.need-to-validate-remaining-amount-care.label')}</Form.Label>

                                <Controller
                                    name="isRemainingAmountIsValid"
                                    control={control}
                                    rules={{ required: 'error-empty' }}
                                    render={({ field }) => (
                                        <ToggleButtonGroup
                                            type="radio"
                                            value={field.value}
                                            onChange={(val) => {
                                                field.onChange(val)
                                                setIsRemainingAmountIsValid(val === 'true')
                                            }}
                                            name="isRemainingAmountIsValid"
                                            style={{marginLeft: '10px'}}
                                        >
                                            <ToggleButton id="isRemainingAmountIsValid-btn-1" value='true' variant='outline-info'>Oui</ToggleButton>
                                            <ToggleButton id="isRemainingAmountIsValid-btn-2" value='false' variant='outline-info'>Non</ToggleButton>
                                        </ToggleButtonGroup>
                                    )}
                                />
                                {formErrors && formErrors.isRemainingAmountIsValid && (
                                    <Form.Control.Feedback type="invalid" style={{display: 'block'}}>
                                        {t(`tiers-payant.manage.form.isRemainingAmountIsValid.errors.${formErrors.isRemainingAmountIsValid.message}`)}
                                    </Form.Control.Feedback>
                                )}
                            </div>
                        </Alert>

                    </Form.Group>
                </div>}

                {type === 'prosthesis_orthodontics' && needToValidateRemainingAmount && <div>
                    <Form.Group className="mb-3" controlId="tiers-payant.is-remaining-amount-is-valid">
                        <Alert variant="warning">
                            <div className="alert-message">
                            <Form.Label>{t('tiers-payant.manage.form.need-to-validate-remaining-amount-prosthesis-orthodontics.label')}</Form.Label>
                            <Controller
                                name="isRemainingAmountIsValid"
                                control={control}
                                rules={{ required: 'error-empty' }}
                                render={({ field }) => (
                                    <ToggleButtonGroup
                                        type="radio"
                                        value={field.value}
                                        onChange={(val) => {
                                            field.onChange(val)
                                            setIsRemainingAmountIsValid(val === 'true')
                                        }}
                                        name="isRemainingAmountIsValid"
                                        style={{marginLeft: '10px'}}
                                    >
                                        <ToggleButton id="isRemainingAmountIsValid-btn-1" value='true' variant='outline-info'>Oui</ToggleButton>
                                        <ToggleButton id="isRemainingAmountIsValid-btn-2" value='false' variant='outline-info'>Non</ToggleButton>
                                    </ToggleButtonGroup>
                                )}
                            />
                            {formErrors && formErrors.isRemainingAmountIsValid && (
                                <Form.Control.Feedback type="invalid" style={{display: 'block'}}>
                                    {t(`tiers-payant.manage.form.isRemainingAmountIsValid.errors.${formErrors.isRemainingAmountIsValid.message}`)}
                                </Form.Control.Feedback>
                            )}
                            </div>
                        </Alert>
                    </Form.Group>
                </div>}

                {type !== 0 && (!needToValidateRemainingAmount || (needToValidateRemainingAmount && isRemainingAmountIsValid)) && <>
                    {type !== 0 && (
                        <Form.Group className="mb-3" controlId="tiers-payant.invoice-file">

                            <Form.Label>
                                {t('tiers-payant.manage.form.invoice-file.label')}
                            </Form.Label>
                            {tiersPayant.invoiceFile && (
                                <div>

                                    Fichier téléchargé: <a target="_blank"
                                                           href={`${apiURL}/api/patient-file/${tiersPayant.invoiceFile.id}?token=${token}`} rel="noreferrer">{tiersPayant.invoiceFile.name}</a>
                                    {!showInvoiceFile && (<div>
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a style={{color: '#4287f5'}}
                                                                  onClick={() => setShowInvoiceFile(!showInvoiceFile)}>Le
                                        modifier ?</a></div>)}
                                </div>
                            )}

                            {showInvoiceFile && (
                                <>
                                    <Form.Control
                                        type="file"
                                        size="lg"
                                        {...register("invoiceFile", {
                                            required: 'error-empty',
                                        })}
                                        disabled={loading}
                                        isInvalid={formErrors && formErrors.invoiceFile}
                                    />
                                    {formErrors && formErrors.invoiceFile && (
                                        <Form.Control.Feedback type="invalid">
                                            {t(`tiers-payant.manage.form.invoice-file.errors.${formErrors.invoiceFile.message}`)}
                                        </Form.Control.Feedback>
                                    )}
                                </>)}
                        </Form.Group>
                    )}
                    {type === 'care' && (
                        <Form.Group className="mb-3" controlId="tiers-payant.insurance-card-file">
                            <Form.Label>
                                {t('tiers-payant.manage.form.insurance-card-file.label')}
                            </Form.Label>

                            {tiersPayant.insuranceCardFile && (
                                <div>
                                    {t('tiers-payant.manage.form.insurance-card-file.already-downloaded')}
                                    <a target="_blank"
                                       href={`${apiURL}/api/patient-file/${tiersPayant.insuranceCardFile.id}?token=${token}`} rel="noreferrer">{tiersPayant.insuranceCardFile.name}</a>
                                    {!showInsuranceCardFile && <div>
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a style={{color: '#4287f5'}}
                                                                       onClick={() => setShowInsuranceCardFile(!showInsuranceCardFile)}>Le
                                        modifier ?</a></div>}
                                </div>
                            )}

                            {showInsuranceCardFile && (<>
                                {hasInsuranceCardFile && <>
                                <Form.Control
                                        type="file"
                                        placeholder={t('tiers-payant.manage.form.insurance-card-file.place-holder')}
                                        size="lg"
                                        {...register("insuranceCardFile", {
                                            required: 'error-empty',
                                        })}
                                        disabled={loading}
                                        isInvalid={formErrors && formErrors.insuranceCardFile}
                                    />
                                    {formErrors && formErrors.insuranceCardFile && (
                                        <Form.Control.Feedback type="invalid">
                                            {t(`tiers-payant.manage.form.insurance-card-file.errors.${formErrors.insuranceCardFile.message}`)}
                                        </Form.Control.Feedback>
                                    )}
                                </>}
                                <Form.Check // prettier-ignore
                                    type="checkbox"
                                    id="hasInsuranceCardFile"
                                    size="lg"
                                    label={t('tiers-payant.manage.form.has-insurance-card-file.label')}
                                    {...register("hasInsuranceCardFile")}
                                    disabled={loading}
                                    onChange={val => {
                                        setHasInsuranceCardFile(!val.target.checked)
                                    }}
                                />
                            </>)}
                        </Form.Group>
                    )}
                    {type === 'prosthesis_orthodontics' && (<>
                        <strong>{t('tiers-payant.manage.form.medical-care-file.label')}</strong>

                        {hasMedicalCareFile && <>
                            {!hasMedicalCareFileToDownload && <Form.Group className="mb-3" controlId="tiers-payant.how-to-manage">
                                <Form.Label>{t('tiers-payant.manage.form.medical-care-file-id.label')}</Form.Label>
                                <Controller
                                    name="medicalCareFileId"
                                    control={control}
                                    rules={{ required: 'error-empty' }}
                                    render={({field}) => (
                                        <div key="medicalCareFileId" className="mb-3">
                                            {Object.keys(tiersPayant.possibleMedicalCareFiles).map((key) => {
                                                return (
                                                    <Form.Check
                                                        type="radio"
                                                        name="medicalCareFileId"
                                                        style={{marginLeft: '10px'}}
                                                        value={tiersPayant.possibleMedicalCareFiles[key].id}
                                                        id={tiersPayant.possibleMedicalCareFiles[key].id}
                                                    >
                                                        <Form.Check.Input
                                                            onChange={(val) => {
                                                                field.onChange(tiersPayant.possibleMedicalCareFiles[key].id)
                                                                setMedicalCareFileId(tiersPayant.possibleMedicalCareFiles[key].id)
                                                            }}
                                                            type="radio"
                                                            name="medicalCareFileId"
                                                            size="lg"
                                                            checked={true === hasMedicalCareFile && tiersPayant.possibleMedicalCareFiles[key].id === medicalCareFileId}
                                                        />
                                                        <Form.Check.Label>
                                                            <a target="_blank"
                                                               href={`${apiURL}/api/patient-file/${tiersPayant.possibleMedicalCareFiles[key].id}?token=${token}`} rel="noreferrer">{tiersPayant.possibleMedicalCareFiles[key].name}</a>&nbsp;
                                                            <small>({tiersPayant.possibleMedicalCareFiles[key].createdAt})</small>
                                                        </Form.Check.Label>
                                                    </Form.Check>
                                                )
                                            })}
                                        </div>
                                    )}
                                />
                            </Form.Group>}

                            <div>
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                <a style={{color: '#4287f5'}}
                                    onClick={() => setHasMedicalCareFileToDownload(!hasMedicalCareFileToDownload)}>
                                {!hasMedicalCareFileToDownload ? 'Télécharger un fichier à la place ?' : 'Selectionner un fichier ?'}
                            </a></div>

                            {hasMedicalCareFileToDownload &&
                                <Form.Group className="mb-3" controlId="tiers-payant.medical-care-file">
                                    <Form.Label>{t('tiers-payant.manage.form.medical-care-file.label')}</Form.Label>
                                    <Form.Control
                                        type="file"
                                        placeholder={t('tiers-payant.manage.form.medical-care-file.place-holder')}
                                        size="lg"
                                        {...register("medicalCareFile", {
                                            required: 'error-empty',
                                        })}
                                        disabled={loading}
                                        isInvalid={formErrors && formErrors.medicalCareFile}
                                    />
                                    {formErrors && formErrors.medicalCareFile && (
                                        <Form.Control.Feedback type="invalid">
                                            {t(`tiers-payant.manage.form.medical-care-file.errors.${formErrors.medicalCareFile.message}`)}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            }
                        </>}
                        <Form.Check // prettier-ignore
                            type="checkbox"
                            className="mb-3"
                            id="hasMedicalCareFile"
                            size="lg"
                            label={t('tiers-payant.manage.form.has-medical-care-file.label')}
                            {...register("hasMedicalCareFile")}
                            disabled={loading}
                            onChange={val => {
                                setHasMedicalCareFile(!val.target.checked)
                            }}
                        />
                    </>)}
                </>}
            </Form>
            <Modal.Footer className="mt-3">
                <Button
                    variant="secondary"
                    onClick={handleClose}
                >
                {t('tiers-payant.manage.button.cancel')}
                </Button>
                <Button variant="primary"  onClick={handleSubmit(onSubmit)}>
                    {t('tiers-payant.manage.button.next')}
                </Button>
            </Modal.Footer>
        </>
    )
}

export default Step1Document